export default function IntroSection() {
  return (
    <div className="rz-section-heading rz-section-heading--split">
      <div>
        <p className="rz-kicker rz-kicker--dark">Pachete</p>
        <h2>Alege varianta potrivită pentru modul în care vrei să primești și să gestionezi cererile.</h2>
      </div>
      <p>
        Poți începe cu o variantă simplă, în care solicitările ajung direct pe email, sau poți merge către un sistem mai avansat, cu panou de administrare și, pentru horeca și cazări, cu plată online integrată.
      </p>
    </div>
  );
}
